import formatter from '@/components/global/mixins/formatterMethods'
import { status } from '@/utils/bookingStatus'

export default {
  mixins: [formatter],

  data () {
    return {
      statuses: {
        confirmation: [
          status.WAITING_FOR_MANAGER_POST_VALIDATION,
          status.WAITING_FOR_CUSTOMER_CONFIRMATION,
        ],
        noDisplay: [
          //status.UNFINISHED_ONLINE_BOOKING,
          status.WAITING_FOR_MANAGER_PRE_VALIDATION,
          status.SUBMITTED_REQUEST,
          status.DENIED_REQUEST,
          status.BEING_PROCESSED
        ],
        noFormat: [
          status.CHANGE_REQUEST,
          status.CANCEL_REQUEST,
          status.CANCELLED,
          status.FINISHED
        ]
      }
    }
  },

  methods: {
    getDeadlines (booking) {
      let cancellation = null
      let confirmation = null

      if (!this.statuses.noDisplay.includes(booking.status)) {
        let deadline = this.formatDeadline(
          booking.cancellation_deadline,
          !this.statuses.noFormat.includes(booking.status),
          booking.hotel
        )

        if (this.statuses.confirmation.includes(booking.status))
          confirmation = deadline
        else
          cancellation = deadline
      }

      return {
        cancellation: cancellation,
        confirmation: confirmation
      }
    },

    formatDeadline (deadline, requireFormat, hotel) {
      if (!hotel) return {
        value: '-',
        class: ''
      }

      let value = ''
      let red = false

      if (deadline) {
        if (this.isDeadlineInTime(deadline)) {
          value = this.formatDateTime(deadline)
        } else {
          if (requireFormat) {
            value = this.$t('booking.cancel_with_charges')
            red = true
          } else {
            value = this.formatDateTime(deadline)
          }
        }
      } else {
        value = this.$t('booking.cancel_with_charges')
        if (requireFormat) red = true
      }

      return {
        value: value,
        class: red ? 'red' : ''
      }
    },

    isDeadlineInTime (deadline) {
      if (deadline) {
        let now = new Date()
        let deadlineDate = new Date(deadline)
        return deadlineDate > now
      } else return false
    },

    cancellationThroughNewWindow (booking) {
      // Status before proposition is automatically in time
      if (this.statuses.noDisplay.includes(booking.status))
        return false
      else
        return !this.isDeadlineInTime(booking.cancellation_deadline)
    },

    getNearestDeadlineDetails (rooms = []) {
      let now = new Date()
      let freeCancellation = true
      let cancellationDeadline = null
      let ret = {
        class: 'red',
        text: this.$t('online.offer.cancelation.non_free_cancelation'),
        date: null
      }

      for (let room of rooms) {
        let roomDeadline = new Date(room.offer.cancellationDeadline)

        if (cancellationDeadline === null || roomDeadline < cancellationDeadline)
          cancellationDeadline = roomDeadline

        if (now > roomDeadline)
          freeCancellation = false
      }

      if (freeCancellation) {
        let val = this.formatDateTimeWithText(cancellationDeadline)

        ret = {
          class: 'green',
          text: this.$t(
            'online.offer.cancelation.free_cancelation',
            {
              until: val.text,
              date: val.value
            }
          ),
          date: cancellationDeadline
        }
      }

      return ret
    }
  }
}
